import { render } from "./IconSigned.vue?vue&type=template&id=21db0046"
import script from "./IconSigned.vue?vue&type=script&lang=js"
export * from "./IconSigned.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__